var escape = require("../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".activity-2018-wrap[data-v-481ef3bd]{background:#a81e1c}.activity-2018-wrap header[data-v-481ef3bd]{width:100%;height:850px;background:url(" + escape(require("assets/activity/top-bg-min.jpg")) + ") no-repeat top}.activity-2018-wrap footer[data-v-481ef3bd]{background-color:#201c19;text-align:center;font-size:16px;line-height:50px;color:#a9a8a8}", ""]);

// exports
